import React from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Badge} from 'reactstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import moment from 'moment';
import 'moment-timezone';
import {getDrivers} from '../Drivers/DriverFunctions';
import {getStaff} from '../Staff/StaffFunctions';
import {getTimeOff, postTimeOff, putTimeOffStatus} from './TimeOffFunctions';

moment.tz.setDefault("America/Halifax");

class TimeOff extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            timeOff: {},
            drivers: {},
            staff: {},
            loading: true,
            currentDate: moment(),
            showModal: false,
            processing: false,
            driver_id: '',
            start_date: '',
            end_date: '',
            start_time: '00:00',
            end_time: '23:59',
            details: '',
        };

        this.loadData = this.loadData.bind(this);
        this.updateField = this.updateField.bind(this);
        this.onDriverSelect = this.onDriverSelect.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
        this.reviewTimeOff = this.reviewTimeOff.bind(this);
        this.changeMonth = this.changeMonth.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        document.title = "Time Off | Custom TMS";
        this.loadData();
    }

    loadData() {
        var self = this;
        self.setState({loading: true});
        getDrivers(function (drivers) {
            getStaff(function (staff) {
                getTimeOff(function (timeOff) {
                    self.setState({
                        drivers: drivers || {},
                        staff: staff || {},
                        timeOff: timeOff || {},
                        loading: false,
                    });
                });
            });
        });
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    updateField(event) {
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value
        });
    }

    onDriverSelect(selected) {
        this.setState({
            driver_id: selected ? selected.value : ''
        });
    }

    submitRequest(event) {
        event.preventDefault();
        this.setState({processing: true});
        var self = this;
        var data = {
            driver_id: this.state.driver_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            start_time: this.state.start_time,
            end_time: this.state.end_time,
            details: this.state.details,
        };
        postTimeOff(data, function (response) {
            self.setState({processing: false});
            if (typeof response.Message !== "undefined" && response.Message.indexOf("submitted") !== -1) {
                Swal("Success!", response.Message, "success");
                self.setState({
                    showModal: false,
                    driver_id: '',
                    start_date: '',
                    end_date: '',
                    start_time: '00:00',
                    end_time: '23:59',
                    details: '',
                });
                self.loadData();
            } else if (typeof response.Message !== "undefined") {
                Swal("Error", response.Message, "error");
            } else {
                Swal("Error", "Could not submit request", "error");
            }
        });
    }

    reviewTimeOff(time_off_id, status) {
        var self = this;
        putTimeOffStatus(time_off_id, status, function (response) {
            if (typeof response.Message !== "undefined" && (response.Message.indexOf("approved") !== -1 || response.Message.indexOf("denied") !== -1)) {
                Swal("Updated", response.Message, "success");
                self.loadData();
            } else if (typeof response.Message !== "undefined") {
                Swal("Error", response.Message, "error");
            } else {
                Swal("Error", "Could not update request", "error");
            }
        });
    }

    changeMonth(direction) {
        this.setState({
            currentDate: this.state.currentDate.clone().add(direction, 'month')
        });
    }

    driverName(driver_id) {
        if (typeof this.state.drivers[driver_id] !== "undefined") {
            var driver = this.state.drivers[driver_id];
            return driver.first_name + " " + driver.last_name;
        }
        return "Driver #" + driver_id;
    }

    staffName(staff_id) {
        if (staff_id && typeof this.state.staff[staff_id] !== "undefined") {
            var staff = this.state.staff[staff_id];
            return staff.first_name + " " + staff.last_name;
        }
        return "";
    }

    statusBadge(status) {
        if (status === 'approved') {
            return <Badge color="success">Approved</Badge>;
        } else if (status === 'denied') {
            return <Badge color="danger">Denied</Badge>;
        }
        return <Badge color="warning">Pending</Badge>;
    }

    renderCalendar() {
        var monthStart = this.state.currentDate.clone().startOf('month');
        var startDay = monthStart.clone().startOf('week');
        var days = [];
        var day = startDay.clone();
        for (var i = 0; i < 42; i++) {
            days.push(day.clone());
            day.add(1, 'day');
        }

        var weeks = [];
        for (i = 0; i < 6; i++) {
            weeks.push(days.slice(i * 7, (i + 1) * 7));
        }

        var today = moment().startOf('day');

        return (
            <div className="table-responsive">
                <table className="table table-bordered text-center" style={{tableLayout: 'fixed'}}>
                    <thead>
                    <tr>
                        {moment.weekdaysShort().map((d, i) => (
                            <th key={i} className="text-center" style={{width: '14.28%'}}>{d}</th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {weeks.map((week, wk) => (
                        <tr key={wk}>
                            {week.map((d, idx) => {
                                var isCurrentMonth = d.isSame(this.state.currentDate, 'month');
                                var isToday = d.isSame(today, 'day');
                                var cellOff = [];
                                Object.values(this.state.timeOff).forEach(function (off) {
                                    var start = moment(off.start_datetime);
                                    var end = moment(off.end_datetime);
                                    if (d.isBetween(start, end, 'day', '[]')) {
                                        cellOff.push(off);
                                    }
                                });
                                return (
                                    <td key={idx}
                                        className={(isCurrentMonth ? "" : "text-muted bg-light ") + (isToday ? "bg-info text-white" : "")}
                                        style={{height: '120px', verticalAlign: 'top', padding: '4px'}}>
                                        <div className="font-weight-bold">{d.date()}</div>
                                        <div style={{maxHeight: '90px', overflowY: 'auto'}}>
                                            {cellOff.map((off) => (
                                                <div key={off.time_off_id} title={off.details}
                                                     className={(off.status === 'approved' ? "badge badge-success" : off.status === 'denied' ? "badge badge-danger" : "badge badge-warning") + " d-block mb-1"}
                                                     style={{fontSize: '10px', whiteSpace: 'normal'}}>
                                                    {this.driverName(off.driver_id)}
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderList(items, showActions) {
        var self = this;
        return (
            <table className={items.length > 0 ? "table table-hover" : "d-none"}>
                <thead>
                <tr>
                    <th>Driver</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Status</th>
                    <th>Details</th>
                    {showActions && <th className="text-right">Actions</th>}
                </tr>
                </thead>
                <tbody>
                {items.map(function (off) {
                    return (
                        <tr key={off.time_off_id}>
                            <td>{self.driverName(off.driver_id)}</td>
                            <td>{moment(off.start_datetime).format('MMM. D/YY h:mm A')}</td>
                            <td>{moment(off.end_datetime).format('MMM. D/YY h:mm A')}</td>
                            <td>{self.statusBadge(off.status)}</td>
                            <td>{off.details}</td>
                            {showActions && (
                                <td className="text-right">
                                    {off.status === 'pending' && (
                                        <>
                                            <Button size="sm" color="success" className="mr-1"
                                                    onClick={() => self.reviewTimeOff(off.time_off_id, 'approved')}>
                                                Approve
                                            </Button>
                                            <Button size="sm" color="danger"
                                                    onClick={() => self.reviewTimeOff(off.time_off_id, 'denied')}>
                                                Deny
                                            </Button>
                                        </>
                                    )}
                                </td>
                            )}
                        </tr>
                    );
                })}
                </tbody>
            </table>
        );
    }

    render() {
        var today = moment().startOf('day');
        var all = Object.values(this.state.timeOff).sort(function (a, b) {
            return moment(a.start_datetime).diff(moment(b.start_datetime));
        });
        var upcoming = all.filter(function (off) {
            return moment(off.end_datetime).isSameOrAfter(today, 'day');
        });
        var previous = all.filter(function (off) {
            return moment(off.end_datetime).isBefore(today, 'day');
        });

        var isApprover = parseInt(this.props.staff_id) === 1;

        var driverOptions = Object.values(this.state.drivers).filter(function (d) {
            return d.status === 1 || d.status === 2;
        }).map(function (d) {
            return {value: d.driver_id, label: d.first_name + " " + d.last_name};
        }).sort(function (a, b) {
            return a.label.localeCompare(b.label);
        });

        return (
            <ContentWrapper>
                <div className="content-heading">
                    <div>Time Off</div>
                    <div className="ml-auto">
                        <Button color="primary" onClick={this.toggleModal}>
                            <i className="fas fa-plus"></i> Request Time Off
                        </Button>
                    </div>
                </div>

                <Row>
                    <Col lg={5}>
                        <div className="card card-default mb-3">
                            <div className="card-header">
                                <div className="card-title">Upcoming Time Off</div>
                            </div>
                            <div className="card-body">
                                {upcoming.length === 0 && <div className="alert alert-info">No upcoming time off</div>}
                                {this.renderList(upcoming, isApprover)}
                            </div>
                        </div>

                        <div className="card card-default">
                            <div className="card-header">
                                <div className="card-title">Previous Time Off</div>
                            </div>
                            <div className="card-body">
                                {previous.length === 0 && <div className="alert alert-info">No previous time off</div>}
                                {this.renderList(previous, false)}
                            </div>
                        </div>
                    </Col>

                    <Col lg={7}>
                        <div className="card card-default">
                            <div className="card-header">
                                <div className="card-title d-flex justify-content-between align-items-center w-100">
                                    <span>{this.state.currentDate.format('MMMM YYYY')}</span>
                                    <div>
                                        <Button size="sm" color="secondary" className="mr-1" onClick={() => this.changeMonth(-1)}>
                                            <i className="fas fa-chevron-left"></i>
                                        </Button>
                                        <Button size="sm" color="secondary" onClick={() => this.changeMonth(1)}>
                                            <i className="fas fa-chevron-right"></i>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {this.renderCalendar()}
                            </div>
                        </div>
                    </Col>
                </Row>

                <Modal isOpen={this.state.showModal} toggle={this.toggleModal} size="md">
                    <ModalHeader toggle={this.toggleModal}>Request Time Off</ModalHeader>
                    <ModalBody className="card card-default">
                        <Form>
                            <FormGroup>
                                <Label>Driver</Label>
                                <Select
                                    name="driver_id"
                                    options={driverOptions}
                                    value={driverOptions.find((o) => o.value === this.state.driver_id) || null}
                                    onChange={this.onDriverSelect}
                                    placeholder="Select a driver..."
                                    isClearable
                                />
                            </FormGroup>
                            <Row>
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label>Start Date</Label>
                                        <Input type="date" name="start_date" value={this.state.start_date} onChange={this.updateField} />
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label>Start Time</Label>
                                        <Input type="time" name="start_time" value={this.state.start_time} onChange={this.updateField} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label>End Date</Label>
                                        <Input type="date" name="end_date" value={this.state.end_date} onChange={this.updateField} />
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup>
                                        <Label>End Time</Label>
                                        <Input type="time" name="end_time" value={this.state.end_time} onChange={this.updateField} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <FormGroup>
                                <Label>Details / Notes</Label>
                                <Input type="textarea" name="details" value={this.state.details} onChange={this.updateField} rows="3" />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.submitRequest}>
                            <i className={(this.state.processing ? "fa fa-spinner fa-spin mr-2" : "d-none")}></i>
                            Submit Request
                        </Button>
                    </ModalFooter>
                </Modal>

            </ContentWrapper>
        );
    }
}

export default TimeOff;
